export default "__VITE_ASSET__b557305b__"